import { AppShell } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IconCalendarEvent } from '@tabler/icons';
import { WindowContext } from '../../Service/Context/WindowContext';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import PageHeader from '../Navigation/PageHeader';
import { RoutingS } from '../../Service/RoutingS';
import { MixpanelS } from '../../Service/MixpanelS';
import { ConstantS } from '../../Service/ConstantS';
import NavDrawer from '../../Atoms/NavDrawer';
import BookitupFooter from '../Navigation/phone/BookitupFooter';
import { openCreateEventModal } from '../Event/CreateEventModal';
import EventsPageFooter from '../Navigation/phone/EventsPageFooter';
import EventListNavBar from './navbar/EventListNavBar';
import WelcomeHeader from './WelcomeHeader';
import EventsPageContent from './EventsPageContent';

const EventsPage = () => {
  const { xs, sm } = useContext(WindowContext);
  const [searchParams] = useSearchParams();
  const [drawerOpened, setDrawerOpened] = useState(false);

  useEffect(() => {
    RoutingS.changeTitle('Events');
    if (searchParams.get('__hstc')) {
      MixpanelS.track(ConstantS.TrackingEvents.OnboardingConfirmed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppShell
      header={<PageHeader />}
      navbar={
        !sm ? (
          <DoubleNavbar>
            <EventListNavBar />
          </DoubleNavbar>
        ) : undefined
      }
      styles={(theme) => ({
        main: {
          overflowX: 'hidden',
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'inherit',
          width: !xs ? '100%' : undefined,
        },
      })}
      footer={
        sm ? (
          <BookitupFooter>
            <EventsPageFooter addHandler={openCreateEventModal} filter={() => setDrawerOpened(true)} />
          </BookitupFooter>
        ) : undefined
      }
    >
      {sm && (
        <NavDrawer
          label="Events"
          icon={<IconCalendarEvent size={32} />}
          opened={drawerOpened}
          onClose={() => setDrawerOpened(false)}
        >
          <EventListNavBar />
        </NavDrawer>
      )}
      <WelcomeHeader />
      <EventsPageContent />
    </AppShell>
  );
};

export default EventsPage;
